/**
 * Parse weight/dimension field (comma or dot as decimal). Returns null if empty, invalid, or ≤ 0.
 */
export function parsePositiveShippingNumber(s: string): number | null {
  const v = parseFloat(String(s ?? "").trim().replace(",", "."));
  if (Number.isNaN(v) || v <= 0) return null;
  return v;
}
